import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuxiliaresModule } from 'src/app/auxiliares/auxiliares.module';
import { ListadoLogReenviosComponent } from './listado-log-reenvios/listado-log-reenvios.component';
import { LogReenviosRoutingModule } from './log-reenvios.routing.module';
import { JsonViewerDialogComponent } from 'src/app/auxiliares/json-viewer-dialog/json-viewer-dialog.component';

@NgModule({
  declarations: [ListadoLogReenviosComponent, JsonViewerDialogComponent],
  imports: [CommonModule, AuxiliaresModule, LogReenviosRoutingModule],
})
export class LogReenviosModule {}
